import React, { useEffect, useState } from "react";
import {
    X,
    Paperclip,
    FileText,
    FileImage,
    FileSpreadsheet,
    File,
    Eye,
    Download,
    Loader2,
    AlertCircle,
} from "lucide-react";
import { LoadingSpinner, ErrorCard } from "../../../components/LoadingSpinner";
import { appealApi } from "../../../api/appealApi";
const AppealAttachmentsDialog = ({
    open,
    appeal,
    onClose,
    onPreview,
}) => {
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [downloadingState, setDownloadingState] = useState(false);

    useEffect(() => {
        if (!open || !appeal?.appealId) {
            return;
        }

        const loadAttachments = async () => {
            try {
                setLoading(true);
                setError("");

                const res = await appealApi.getAppealAttachments(
                    appeal.appealId
                );

                const data = res?.data?.Data ?? res?.Data ?? [];

                setAttachments(data);
            } catch (err) {
                console.error("Failed to load attachments:", err);
                setError("Unable to load attachments.");
                setAttachments([]);
            } finally {
                setLoading(false);
            }
        };

        loadAttachments();
    }, [open, appeal?.appealId]);

    if (!open) {
        return null;
    }

    const getFileIcon = (attachment) => {
        const contentType = attachment.ContentType?.toLowerCase() || "";

        if (contentType.includes("pdf")) {
            return <FileText size={20} color="#DC2626" />;
        }

        if (contentType.includes("image")) {
            return <FileImage size={20} color="#2563EB" />;
        }

        if (
            contentType.includes("excel") ||
            contentType.includes("spreadsheet")
        ) {
            return <FileSpreadsheet size={20} color="#059669" />;
        }

        return <File size={20} color="#64748B" />;
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return "0 KB";

        if (bytes < 1024) {
            return `${bytes} B`;
        }

        if (bytes < 1024 * 1024) {
            return `${(bytes / 1024).toFixed(1)} KB`;
        }

        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const handleDownload = async (attachment) => {
        try {

            setDownloadingState(true);
            const res = await appealApi.getAttachmentFile(
                attachment.AppealAttachmentId
            );

            const blob = res.data;

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download =
                attachment.OriginalFileName || "attachment";
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            setDownloadingState(false);
        } catch (err) {
            setDownloadingState(false);
            console.error("Failed to download attachment:", err);
            //alert("Unable to download attachment.");
        }
    };

    return (
        <div   
            data-cy="appeal-attachments-dialog"
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 2000,
                background: "rgba(15, 23, 42, 0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 20,
            }}
            onClick={onClose}
        >
            <>
                <style>
                    {`
            @media (max-width: 600px) {
                .attachment-row {
                    align-items: flex-start !important;
                    flex-wrap: wrap;
                }

                .attachment-actions {
                    width: 100%;
                    margin-left: 0;
                }

                .attachment-actions button {
                    flex: 1;
                }
            }

            @media (max-width: 380px) {
                .attachment-row {
                    gap: 9px !important;
                    padding: 10px !important;
                }

                .attachment-actions {
                    margin-left: 0;
                    margin-right: 0;
                }

                .attachment-actions button {
                    padding: 7px 8px !important;
                }
            }
        `}
                </style>

                {/* Your existing page JSX */}
            </>
            <div
                style={{
                    width: "100%",
                    maxWidth: 650,
                    maxHeight: "80vh",
                    background: "#fff",
                    
                    borderRadius: 16,
                    boxShadow: "0 25px 60px rgba(0,0,0,.18)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div
                    style={{
                        padding: "16px 18px",
                        borderBottom: "1px solid #E5E7EB",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between", 
                      //  background: "var(--gradient-dark) !important",
                        
                       // fontWeight: "600 !important"
                    }}

                    
                >
                    <div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                fontSize: 16,
                                fontWeight: 700,
                                color: "#111827"
                               // color: "#fff !important",
                            }}
                        >
                            <Paperclip size={18} color="#0D9488" />
                            Attachments
                        </div>

                        <div
                            style={{
                                marginTop: 3,
                                fontSize: 11,
                                color: "#94A3B8",
                            }}
                        >
                            {appeal?.appealNumber
                                ? `Appeal #${appeal.appealNumber}`
                                : "Appeal attachments"}
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={onClose}
                        data-cy="close-attachments-dialog"
                        style={{
                            width: 34,
                            height: 34,
                            border: "none",
                            borderRadius: 8,
                            background: "#F3F4F6",
                            color: "#64748B",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Body */}
                <div
                    style={{
                        padding: 16,
                        overflowY: "auto",
                    }}
                >
                    {loading && (
                        //<div
                        //    style={{
                        //        minHeight: 180,
                        //        display: "flex",
                        //        alignItems: "center",
                        //        justifyContent: "center",
                        //        gap: 8,
                        //        color: "#64748B",
                        //        fontSize: 13,
                        //    }}
                        //>
                        //    <Loader2
                        //        size={18}
                        //        className="spin"
                        //    />
                        //    Loading attachments...
                        //</div>

                        
                        <div
                              style={{
                                  padding: 40,
                                  textAlign: "center",
                              }}
                          >
                            <LoadingSpinner message="Loading attachments..." />
                          </div>
                    )}

                    {!loading && error && (
                        <div
                            style={{
                                padding: 18,
                                borderRadius: 10,
                                background: "#FEF2F2",
                                border: "1px solid #FECACA",
                                color: "#B91C1C",
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                fontSize: 13,
                            }}
                        >
                            <AlertCircle size={17} />
                            {error}
                        </div>
                    )}

                    {!loading &&
                        !error &&
                        attachments.length === 0 && (
                            <div
                                style={{
                                    minHeight: 180,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#94A3B8",
                                    gap: 8,
                                }}
                            >
                                <Paperclip size={30} />

                                <div
                                    style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                    }}
                                >
                                    No attachments
                                </div>

                                <div
                                    style={{
                                        fontSize: 11,
                                    }}
                                >
                                    This appeal doesn't have any attachments.
                                </div>
                            </div>
                        )}

                    {/*{!loading &&*/}
                    {/*    !error &&*/}
                    {/*    attachments.length > 0 && (*/}
                    {/*        <div*/}
                    {/*            style={{*/}
                    {/*                display: "flex",*/}
                    {/*                flexDirection: "column",*/}
                    {/*                gap: 8,*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            {attachments.map((attachment) => (*/}
                    {/*                <div*/}
                    {/*                    key={attachment.AppealAttachmentId}*/}
                    {/*                    style={{*/}
                    {/*                        display: "flex",*/}
                    {/*                        alignItems: "center",*/}
                    {/*                        gap: 12,*/}
                    {/*                        padding: "12px 13px",*/}
                    {/*                        border: "1px solid #E5E7EB",*/}
                    {/*                        borderRadius: 11,*/}
                    {/*                        background: "#FAFAFA",*/}
                    {/*                    }}*/}
                    {/*                >*/}
                    {/*                    */}{/* File Icon */}
                    {/*                    <div*/}
                    {/*                        style={{*/}
                    {/*                            width: 38,*/}
                    {/*                            height: 38,*/}
                    {/*                            borderRadius: 9,*/}
                    {/*                            background: "#fff",*/}
                    {/*                            border: "1px solid #E5E7EB",*/}
                    {/*                            display: "flex",*/}
                    {/*                            alignItems: "center",*/}
                    {/*                            justifyContent: "center",*/}
                    {/*                            flexShrink: 0,*/}
                    {/*                        }}*/}
                    {/*                    >*/}
                    {/*                        {getFileIcon(attachment)}*/}
                    {/*                    </div>*/}

                    {/*                    */}{/* File Information */}
                    {/*                    <div*/}
                    {/*                        style={{*/}
                    {/*                            flex: 1,*/}
                    {/*                            minWidth: 0,*/}
                                                
                    {/*                        }}*/}
                    {/*                    >*/}
                    {/*                        <div*/}
                    {/*                            style={{*/}
                    {/*                                fontSize: 13,*/}
                    {/*                                fontWeight: 650,*/}
                    {/*                                color: "#334155",*/}
                    {/*                                overflow: "hidden",*/}
                    {/*                                textOverflow: "ellipsis",*/}
                    {/*                                whiteSpace: "nowrap",*/}
                    {/*                            }}*/}
                    {/*                            title={attachment.OriginalFileName}*/}
                    {/*                        >*/}
                    {/*                            {attachment.OriginalFileName}*/}
                    {/*                        </div>*/}

                    {/*                        <div*/}
                    {/*                            style={{*/}
                    {/*                                marginTop: 3,*/}
                    {/*                                fontSize: 10.5,*/}
                    {/*                                color: "#94A3B8",*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            {formatFileSize(*/}
                    {/*                                attachment.FileSize*/}
                    {/*                            )}*/}
                    {/*                            {" • "}*/}
                    {/*                            {attachment.ContentType ||*/}
                    {/*                                attachment.FileExtension}*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    */}{/* Actions */}
                    {/*                    <div*/}
                    {/*                        style={{*/}
                    {/*                            display: "flex",*/}
                    {/*                            gap: 6,*/}
                    {/*                            flexShrink: 0,*/}
                    {/*                        }}*/}
                    {/*                    >*/}
                    {/*                        {attachment.CanPreview && (*/}
                    {/*                            <button*/}
                    {/*                                type="button"*/}
                    {/*                                onClick={() =>*/}
                    {/*                                    onPreview(attachment)*/}
                    {/*                                }*/}
                    {/*                                style={{*/}
                    {/*                                    padding: "7px 10px",*/}
                    {/*                                    borderRadius: 8,*/}
                    {/*                                    border:*/}
                    {/*                                        "1px solid rgba(37,99,235,.2)",*/}
                    {/*                                    background:*/}
                    {/*                                        "rgba(37,99,235,.07)",*/}
                    {/*                                    color: "#2563EB",*/}
                    {/*                                    fontSize: 11,*/}
                    {/*                                    fontWeight: 700,*/}
                    {/*                                    cursor: "pointer",*/}
                    {/*                                    display: "inline-flex",*/}
                    {/*                                    alignItems: "center",*/}
                    {/*                                    gap: 5,*/}
                    {/*                                }}*/}
                    {/*                            >*/}
                    {/*                                <Eye size={13} />*/}
                    {/*                                Preview*/}
                    {/*                            </button>*/}
                    {/*                        )}*/}

                    {/*                        <button*/}
                    {/*                            type="button"*/}
                    {/*                            onClick={() =>*/}
                    {/*                                handleDownload(attachment)*/}
                    {/*                            }*/}
                    {/*                            style={{*/}
                    {/*                                padding: "7px 10px",*/}
                    {/*                                borderRadius: 8,*/}
                    {/*                                border:*/}
                    {/*                                    "1px solid rgba(13,148,136,.2)",*/}
                    {/*                                background:*/}
                    {/*                                    "rgba(13,148,136,.07)",*/}
                    {/*                                color: "#0D9488",*/}
                    {/*                                fontSize: 11,*/}
                    {/*                                fontWeight: 700,*/}
                    {/*                                cursor: "pointer",*/}
                    {/*                                display: "inline-flex",*/}
                    {/*                                alignItems: "center",*/}
                    {/*                                gap: 5,*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            <Download size={13} />*/}
                    {/*                            Download*/}
                    {/*                        </button>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            ))}*/}
                    {/*        </div>*/}
                    {/*    )}*/}

                    {!loading &&
                        !error &&
                        attachments.length > 0 && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                    width: "100%",
                                }}
                            >
                                {attachments.map((attachment) => (
                                    <div
                                        key={attachment.AppealAttachmentId}
                                        className="attachment-row"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 12,
                                            padding: "12px 13px",
                                            border: "1px solid #E5E7EB",
                                            borderRadius: 11,
                                            background: "#FAFAFA",
                                            boxSizing: "border-box",
                                            width: "100%",
                                        }}
                                    >
                                        {/* File Icon */}
                                        <div
                                            style={{
                                                width: 38,
                                                height: 38,
                                                minWidth: 38,
                                                borderRadius: 9,
                                                background: "#fff",
                                                border: "1px solid #E5E7EB",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {getFileIcon(attachment)}
                                        </div>

                                        {/* File Information */}
                                        <div
                                            style={{
                                                flex: "1 1 auto",
                                                minWidth: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: 13,
                                                    fontWeight: 650,
                                                    color: "#334155",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                                title={attachment.OriginalFileName}
                                            >
                                                {attachment.OriginalFileName}
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 3,
                                                    fontSize: 10.5,
                                                    color: "#94A3B8",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {formatFileSize(attachment.FileSize)}
                                                {" • "}
                                                {attachment.ContentType ||
                                                    attachment.FileExtension}
                                            </div>
                                        </div>

                                        {/* Actions */}
                                        <div
                                            className="attachment-actions"
                                            style={{
                                                display: "flex",
                                                gap: 6,
                                                flexShrink: 0,
                                            }}
                                        >
                                            {attachment.CanPreview && (
                                                <button
                                                    type="button"
                                                    className={"previewAttachmentButon"}
                                                    onClick={() => onPreview(attachment)}
                                                    data-cy={`preview-attachment-${attachment.AppealAttachmentId}`}
                                                    style={{
                                                        padding: "7px 10px",
                                                        borderRadius: 8,
                                                        border:
                                                            "1px solid rgba(37,99,235,.2)",
                                                        background:
                                                            "rgba(37,99,235,.07)",
                                                        color: "#2563EB",
                                                        fontSize: 11,
                                                        fontWeight: 700,
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: 5,
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <Eye size={13} />
                                                    <span>Preview</span>
                                                </button>
                                            )}

                                            <button
                                                type="button"
                                                data-cy={`download-attachment-${attachment.AppealAttachmentId}`}
                                                onClick={() =>
                                                    handleDownload(attachment)
                                                }
                                                style={{
                                                    padding: "7px 10px",
                                                    borderRadius: 8,
                                                    border:
                                                        "1px solid rgba(13,148,136,.2)",
                                                    background:
                                                        "rgba(13,148,136,.07)",
                                                    color: "#0D9488",
                                                    fontSize: 11,
                                                    fontWeight: 700,
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 5,
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                <Download size={13} />
                                                <span>{downloadingState ? "Downloading..." : "Download" } </span>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                </div>
            </div>
        </div>


    );
};



export default AppealAttachmentsDialog;